import React, { useState } from "react";
import PropTypes from "prop-types";
import { Carousel, CarouselItem, CarouselIndicators } from "reactstrap";
import ctvPlacement from "../../../assets/images/ctv_preview_modal.png";
import CreatomateAdPreview from "./creatomate-ad-preview";
import AdDesignPreview from "../../partner-dashboard/components/ad-designs/ad-design-preview";
import "./preview-carousel.styles.scss";

const propTypes = {
  template: PropTypes.shape({
    displayName: PropTypes.string.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    previewPath: PropTypes.string.isRequired,
    placements: PropTypes.arrayOf(PropTypes.string).isRequired,
    primaryMimeType: PropTypes.string.isRequired,
    isCreatomateTemplate: PropTypes.bool.isRequired,
    renderedJsonDocument: PropTypes.string.isRequired
  }).isRequired,
  uniqueKey: PropTypes.string.isRequired
};

const items = [
  {
    key: "ctv",
    src: ctvPlacement,
    altText: "Connected TV",
    adScale: 0.9,
    topPosition: "1.3%",
    leftPosition: "7.6%"
  }
];

const CtvPreviewPlacement = ({ template, uniqueKey }) => {
  const containerWidth = 1000;
  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);
  const VIDEO_SIZE_RATIO = 0.56;
  const BG_SIZE_RATIO = 0.6;

  const goToIndex = newIndex => {
    if (animating) return;
    setActiveIndex(newIndex);
  };

  const slides = items.map(item => (
    <CarouselItem
      onExiting={() => setAnimating(true)}
      onExited={() => setAnimating(false)}
      key={item.key}
    >
      <div
        className="ad-design__carousel--sample-placement-bg"
        style={{
          backgroundImage: `url("${item.src}")`,
          width: containerWidth,
          height: containerWidth * BG_SIZE_RATIO,
          border: "1px solid transparent"
        }}
      >
        <div
          style={{
            position: "absolute",
            top: item.topPosition,
            left: item.leftPosition,
            width: containerWidth * item.adScale,
            height: containerWidth * item.adScale * VIDEO_SIZE_RATIO
          }}
        >
          {template.isCreatomateTemplate ? (
            <CreatomateAdPreview
              key={uniqueKey}
              creative={template}
              width={containerWidth * item.adScale}
              height={containerWidth * item.adScale * VIDEO_SIZE_RATIO}
            />
          ) : (
            <AdDesignPreview
              url={template.previewPath}
              mimeType={template.primaryMimeType}
              title={template.displayName}
              width={containerWidth * item.adScale}
              height={containerWidth * item.adScale * VIDEO_SIZE_RATIO}
              isCreatomateTemplate={template.isCreatomateTemplate}
              exactSize
            />
          )}
        </div>
      </div>
    </CarouselItem>
  ));

  return (
    <div className="py-0" data-testid="ctv-preview-placement">
      <Carousel
        className="ad-design__carousel"
        activeIndex={activeIndex}
        next={() => {}}
        previous={() => {}}
      >
        <CarouselIndicators items={items} activeIndex={activeIndex} onClickHandler={goToIndex} />
        {slides}
      </Carousel>
      <small>
        * The above sample placements are for example purposes only. Your specific ad may be
        displayed on other websites.
      </small>
    </div>
  );
};

CtvPreviewPlacement.propTypes = propTypes;

export default CtvPreviewPlacement;
